import React from 'react';
import '../App.css';
import './project1.css';
import './project4.css';
import GT_Auto from '../images/GT_automotive.mp4'; 
import Phone from '../images/phone.png';
import Screen_shot1 from '../images/ScreenShot_GTAuto.png';
import Comp from '../images/computer_portfolio.png';
import Comp_Screen from '../images/GT_Automotive.png';
import Phone2 from '../images/holding_phone.png';
import Screen_shot2 from '../images/ScreenShot_GTAuto2.png'; 
import Comp2 from '../images/apple.png';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js' 

const Project4 = () => {

    useScrollBehavior();

	return (
		<div id='project_div1'>
			<div className='module_project' id='project_moduleOne'>
				<div id='project_div2'>
					<video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
					<source src={GT_Auto} type="video/mp4" fetchpriority="high"/>
    						Your browser does not support the video tag.
  					</video>
					<div id='project_div2_heading_container'>
					<div id='project_div2_heading1'>
						<h1>GT Automotive & Towing</h1>
					</div>
					<div id='project_div2_heading2'>
						<h3>Scope: Website / WebDev, Hosting, Search Engine Optimization</h3>
						<a className="href_project" href="/">
                        <h3 id='under_construction_p4'>Website: Under Construction</h3></a>
					</div>
					
					<div id='project_div2_heading3'>
						<p>GT Automotive & Towing is a Full-Service Automotive Repair Shop, with 
                            experience in a vast number of automotive repair types. Their areas of repair 
                            expertise include a variety of regular routine maintenance items, as well as 
                            many specialty and extensive repairs.</p>
					</div>
					</div>
					<div className="phone-frame">
  						<img src={Phone} alt="Phone Frame" className="frame" />
  						<img src={Screen_shot1} alt="Screen Content" className="screen_project4" />
					</div>

					
				</div>
					
				
			</div>
			<div className='module_project' id='project_moduleTwo'>
				<div id='project_mod2_container'>
					<div id='project_mod2_inner1'>
						<h1 id='about_h1'>About the Project</h1>
						<h1>GT Automotive & Towing</h1>
					</div>
					<div id='project_mod2_inner2'>
						<p>We turbocharged GT_Automotive's online presence with a sleek, 
                            high-performance website built for speed, visibility, and reliability. 
                            Through precision SEO and dependable hosting, we've helped them pull 
                            ahead of the competition, attract more customers, and showcase their 
                            expertise in keeping vehicles running at peak performance..</p>
					</div>
				</div>

			</div>
			<div className='module_project' id='project_moduleThree'>
				<div id="mod3_container">
  					<div className="frame-container">
                	{/* Computer frame image */}
                		<img src={Comp} alt="Computer Frame" className="computer-frame" />

                		{/* Computer screen content */}
                		<div className="screen-content">
                    		<img src={Comp_Screen} alt="Screenshot inside computer screen" />
                		</div>
            		</div>
				</div>
			</div>
			<div className='module_project' id='project_moduleFour'>
				<div id='mod4_container'>
					
					<div id='mod4_div2_5'>
						<div className="frame-container_mod4">
                		{/* Computer frame image */}
                		<img src={Comp2} alt="Computer Frame2" className="computer-frame2" />

                		{/* Computer screen content */}
                		<div className="screen-content2">
                    		<img src={Comp_Screen} alt="Screenshot inside computer screen2" />
                		</div>
            		</div>

					</div>
					<div id='mod4_div3'>
						<div className="phone-frame2">
  							<img src={Phone2} alt="Phone Frame2" className="frame2" />
  							<img src={Screen_shot2} alt="Screen Content2" className="screen2" />
						</div>

					</div>
				</div>
			</div>
			<Footer/>
			
		</div>
	);
};

export default Project4;